export default __webpack_public_path__ + "static/media/we-educate.7e9430c2.svg";